// @ts-check
import React, { Component } from "react"
import { createPortal } from "react-dom"
import { BlockContextConsumer } from "../ContextProviders"
import RenderBlockTypeAttributes from "./RenderBlockTypeAttributes"
import { ThemeProvider } from "emotion-theming"
import stackerDarkTheme from "ui/styleHelpers/stackerDarkTheme"

class BlockAttributesPortal extends Component {
    render() {
        const children = (
            <BlockContextConsumer>
                {context =>
                    context.block && (
                        <ThemeProvider theme={stackerDarkTheme}>
                            <div
                                className="RenderBlockTypeAttributes"
                                onClick={event => event.stopPropagation()}
                            >
                                <div className="RenderBlockTypeAttributes-content">
                                    <RenderBlockTypeAttributes
                                        block={context.block}
                                        context={context}
                                    />
                                </div>
                            </div>
                        </ThemeProvider>
                    )
                }
            </BlockContextConsumer>
        )

        return createPortal(children, document.getElementById("attributes"))
    }
}

BlockAttributesPortal.propTypes = {}

export default BlockAttributesPortal



// WEBPACK FOOTER //
// ./src/features/editor/attributes/BlockAttributesPortal.js